<template>
  <div class="checklist-container">
    <ul>
      <li v-for="item in checkList" :key="item">
        <CheckboxIcon class="icon" />
        <FriedParagraph class="text" :size="ParagraphSize.Small">{{ item }}</FriedParagraph>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { ParagraphSize } from '@getaccept/fried-tofu';
import CheckboxIcon from '../assets/checkbox.svg';

export default defineComponent({
  components: { CheckboxIcon },
  props: {
    checkList: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup() {
    return {
      ParagraphSize,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '../scss/colors';

.checklist-container {
  background-color: $light-purple;
  border-radius: var(--radius-medium);
  padding: var(--spacing-100);
  min-height: 190px;

  ul {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-75);
    padding: 0;
    margin: 0;

    li {
      display: flex;
      gap: var(--spacing-50);
      align-items: center;

      .text {
        color: $dark-purple;
      }

      .icon {
        flex-shrink: 0;
        color: $dark-purple;
      }
    }
  }
}
</style>
